// extracted by mini-css-extract-plugin
export var arrow = "Amenities-module--arrow--ca2f1";
export var backButton = "Amenities-module--backButton--06403";
export var backgroundImage = "Amenities-module--backgroundImage--2454d";
export var card = "Amenities-module--card--f4835";
export var cardsWrapper = "Amenities-module--cardsWrapper--237d8";
export var carousel = "Amenities-module--carousel--44244";
export var carouselContainer = "Amenities-module--carouselContainer--fe77c";
export var container = "Amenities-module--container--e1df1";
export var decor = "Amenities-module--decor--bbfc2";
export var decorLine = "Amenities-module--decorLine--7d55e";
export var divider = "Amenities-module--divider--6c67a";
export var foregroundImage = "Amenities-module--foregroundImage--4083e";
export var image = "Amenities-module--image--5cdc3";
export var info = "Amenities-module--info--1653c";
export var mobileTabs = "Amenities-module--mobileTabs--6f521";
export var nextButton = "Amenities-module--nextButton--ff1b9";
export var relativeWrapper = "Amenities-module--relativeWrapper--abf8d";
export var selected = "Amenities-module--selected--d5cc9";
export var tab = "Amenities-module--tab--6b854";
export var tabs = "Amenities-module--tabs--98945";
export var textContainer = "Amenities-module--textContainer--1d24d";